import React, { useState } from 'react';
import {
  Container,
  Typography,
  Grid,
  Card,
  CardContent,

  Box,
  Button,

  Paper,

  List,
  ListItem,
  ListItemIcon,
  ListItemText,

  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,

  useTheme,
  useMediaQuery,
  alpha,

  Alert,
  Snackbar,
  Zoom,
  Fade,
  Grow,

} from '@mui/material';
import { keyframes } from '@emotion/react';
import Navbar from '../Navbar';
import HomeFooter from '../HomeFooter';


// ALL ICONS IMPORTED
import DashboardIcon from '@mui/icons-material/Dashboard';
import SchoolIcon from '@mui/icons-material/School';
import GroupsIcon from '@mui/icons-material/Groups';
import AssignmentIcon from '@mui/icons-material/Assignment';
import AssessmentIcon from '@mui/icons-material/Assessment';
import VideoCallIcon from '@mui/icons-material/VideoCall';
import ChatIcon from '@mui/icons-material/Chat';

import PersonAddIcon from '@mui/icons-material/PersonAdd';
import QrCodeScannerIcon from '@mui/icons-material/QrCodeScanner';

import DownloadIcon from '@mui/icons-material/Download';

import CheckCircleIcon from '@mui/icons-material/CheckCircle';

import PeopleAltIcon from '@mui/icons-material/PeopleAlt';
import LocalLibraryIcon from '@mui/icons-material/LocalLibrary';

import MenuBookIcon from '@mui/icons-material/MenuBook';
import QuizIcon from '@mui/icons-material/Quiz';
import WorkspacePremiumIcon from '@mui/icons-material/WorkspacePremium';

import PaymentsIcon from '@mui/icons-material/Payments';

import SportsIcon from '@mui/icons-material/Sports';

import AnalyticsIcon from '@mui/icons-material/Analytics';
import ManageAccountsIcon from '@mui/icons-material/ManageAccounts';

import WorkspacesIcon from '@mui/icons-material/Workspaces';
import DirectionsBusIcon from '@mui/icons-material/DirectionsBus';
import PlayCircleIcon from '@mui/icons-material/PlayCircle';


// Animation keyframes
const floatAnimation = keyframes`
  0% { transform: translateY(0px); }
  50% { transform: translateY(-10px); }
  100% { transform: translateY(0px); }
`;


const ImpulzELMS = () => {

  const logoImage = `${process.env.PUBLIC_URL}/images/impulz-logo.png`;
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'));
  const [attendanceModal, setAttendanceModal] = useState(false);
  const [meetingModal, setMeetingModal] = useState(false);
  const [studentModal, setStudentModal] = useState(false);
  const [reportModal, setReportModal] = useState(false);
  const [paymentModal, setPaymentModal] = useState(false);
  const [analyticsModal, setAnalyticsModal] = useState(false);
  const [notification, setNotification] = useState({ open: false, message: '', type: 'success' });

  const [assignmentModal, setAssignmentModal] = useState(false);
  const [examModal, setExamModal] = useState(false);
  const [certificateModal, setCertificateModal] = useState(false);

  const [libraryModal, setLibraryModal] = useState(false);
  const [transportModal, setTransportModal] = useState(false);


  const handleAttendanceSubmit = () => {
    setAttendanceModal(false);
    showNotification('Attendance marked successfully!', 'success');
  };

  const showNotification = (message, type) => {
    setNotification({ open: true, message, type });
  };

  const handleCloseNotification = () => {
    setNotification({ ...notification, open: false });
  };


  const statsCards = [
    { title: 'Total Students', value: '2,450', icon: <GroupsIcon />, color: theme.palette.primary.main, change: '+12%', detail: 'Active: 2,300' },
    { title: 'Faculty Members', value: '156', icon: <SchoolIcon />, color: theme.palette.secondary.main, change: '+8%', detail: 'Departments: 8' },
    { title: 'Active Courses', value: '84', icon: <LocalLibraryIcon />, color: theme.palette.success.main, change: '+15%', detail: 'Categories: 12' },
    { title: 'Avg Attendance', value: '89%', icon: <CheckCircleIcon />, color: theme.palette.warning.main, change: '+2%', detail: 'Today: 92%' },
    { title: 'Live Sessions', value: '18', icon: <VideoCallIcon />, color: theme.palette.error.main, change: '+6', detail: 'Participants: 450' },
    { title: 'Assignment Tracking', value: '342', icon: <AssignmentIcon />, color: theme.palette.info.main, change: '-24', detail: 'Overdue: 12' },
  ];

  const quickActions = [
    { label: 'Attendance', icon: <QrCodeScannerIcon />, action: () => setAttendanceModal(true), color: 'primary' },
    { label: 'Schedule Meeting', icon: <VideoCallIcon />, action: () => setMeetingModal(true), color: 'secondary' },
    { label: 'Add Student', icon: <PersonAddIcon />, action: () => setStudentModal(true), color: 'success' },
    { label: 'Generate Report', icon: <AssessmentIcon />, action: () => setReportModal(true), color: 'warning' },
    { label: 'Process Payment', icon: <PaymentsIcon />, action: () => setPaymentModal(true), color: 'info' },
    { label: 'View Analytics', icon: <AnalyticsIcon />, action: () => setAnalyticsModal(true), color: 'error' },
    { label: 'Create Assignment', icon: <AssignmentIcon />, action: () => setAssignmentModal(true), color: 'primary' },
    { label: 'Schedule Exam', icon: <QuizIcon />, action: () => setExamModal(true), color: 'secondary' },
    { label: 'Certificate', icon: <WorkspacePremiumIcon />, action: () => setCertificateModal(true), color: 'success' },
    { label: 'Library', icon: <MenuBookIcon />, action: () => setLibraryModal(true), color: 'warning' },
    { label: 'Transport Update', icon: <DirectionsBusIcon />, action: () => setTransportModal(true), color: 'info' },

  ];

  const allFeatures = [
    {
      category: 'Student Management',
      features: [
        'Student Registration & Enrollment',
        'Admission Process Management',
        'Student Profile Management',
        'Academic Records & Transcripts',
        'Attendance Tracking & Reports',
        'Performance Analytics',
        'Disciplinary Records',
        'Alumni Management',
        'Student Portfolio'
      ],
      icon: <GroupsIcon />,
      color: 'primary'
    },
    {
      category: 'Academic Management',
      features: [
        'Course & Curriculum Management',
        'Timetable Scheduling',
        'Exam & Assessment Management',
        'Gradebook & Result Processing',
        'Assignment Management',
        'Lesson Planning',
        'Learning Objectives Tracking',
        'Academic Calendar',
        'Credit System Management',
        'Certificate Generation'
      ],
      icon: <SchoolIcon />,
      color: 'secondary'
    },
    {
      category: 'Faculty Management',
      features: [
        'Teacher Profiles & Credentials',
        'Subject Allocation to Teachers',
        'Performance Evaluation',
        'Leave & Attendance Management',
        'Professional Development',
        'Communication Portal',
        'Resource Allocation',
        'Mentorship Programs',
        'Research Management'
      ],
      icon: <PeopleAltIcon />,
      color: 'success'
    },
    {
      category: 'Financial Management',
      features: [
        'Fee Structure Management',
        'Online Payment Gateway',
        'Fee Collection & Receipts',
        'Scholarship Management',
        'Financial Aid Processing',
        'Expense Management',
        'Budget Planning',
        'Financial Reports',
        'Tax Compliance',
        'Audit Trail'
      ],
      icon: <PaymentsIcon />,
      color: 'warning'
    },
    {
      category: 'Communication System',
      features: [
        'Parent-Teacher Communication',
        'Announcements & Notices',
        'SMS & Email Integration',
        'Emergency Alert',
        'Discussion Forums',
        'Event Management',
        'Newsletter System',
        'Feedback Collection',
        'Survey Management',
        'Complaint Resolution'
      ],
      icon: <ChatIcon />,
      color: 'info'
    },
    {
      category: 'Online Learning',
      features: [
        'Virtual Classroom',
        'Live Video Lectures',
        'Recorded Sessions',
        'Interactive Whiteboard',
        'Screen Sharing',
        'Online Assessments',
        'E-learning Content',
        'Discussion Boards',
        'Collaborative Tools'
      ],
      icon: <VideoCallIcon />,
      color: 'error'
    },
    {
      category: 'Library Management',
      features: [
        'Digital Catalog',
        'Book Issuance & Returns',
        'Fine Management',
        'Reservation System',
        'E-books & Journals',
        'Research Database',
        'Library Analytics',
        'Inventory Management',
        'Donation Management',
        'Reading Lists'
      ],
      icon: <MenuBookIcon />,
      color: 'primary'
    },
    {
      category: 'Transport Management',
      features: [
        'Vehicle Management',
        'Route Optimization',
        'GPS Tracking',
        'Driver Management',
        'Fuel Management',
        'Maintenance Scheduling',
        'Student Pickup/Drop',
        'Real-time Tracking',
        'Transport Fees',
        'Green Portal'
      ],
      icon: <DirectionsBusIcon />,
      color: 'secondary'
    },

    {
      category: 'Sports & Activities',
      features: [
        'Sports Team Management',
        'Event Scheduling',
        'Achievement Tracking',
        'Equipment Management',
        'Coach Allocation',
        'Tournament Management',
        'Participation Records',
        'Facility Booking',
        'Health & Fitness',
        'Performance Analytics'
      ],
      icon: <SportsIcon />,
      color: 'info'
    },
    {
      category: 'Administration',
      features: [
        'Staff Management',
        'Leave Management',
        'Payment Processing',
        'Recruitment',
        'Training Management',
        'Performance Appraisal',
        'Document Management',
        'Policy Management',
        'Compliance Tracking',
        'Organization Structure'
      ],
      icon: <ManageAccountsIcon />,
      color: 'error'
    }
  ];

  const renderDashboard = () => (
    <>
      {/* Stats Overview */}
      <Grid container spacing={3} sx={{ mb: 4 }}>
        {statsCards.map((stat, index) => (
          <Grid item xs={12} sm={6} md={4} lg={2} key={index}>
            <Grow in timeout={index * 200}>
              <Paper
                sx={{
                  p: 3,
                  borderRadius: 3,
                  height: '100%',
                  transition: 'all 0.3s',
                  '&:hover': {
                    transform: 'translateY(-4px)',
                    boxShadow: theme.shadows[8]
                  }
                }}
              >
                <Box sx={{ display: 'flex', alignItems: 'center', mb: 2 }}>
                  <Box
                    sx={{
                      p: 1.5,
                      borderRadius: 2,
                      bgcolor: alpha(stat.color, 0.1),
                      color: stat.color,
                      mr: 2
                    }}
                  >
                    {stat.icon}
                  </Box>
                  <Box>
                    <Typography variant="caption" color="text.secondary">
                      {stat.title}
                    </Typography>
                    <Typography variant="h5" sx={{ fontWeight: 700 }}>
                      {stat.value}
                    </Typography>
                  </Box>
                </Box>
                <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                  <Typography variant="caption" sx={{ color: 'text.secondary' }}>
                    {stat.detail}
                  </Typography>
                  <Typography variant="caption" sx={{
                    color: stat.change.startsWith('+') ? 'success.main' : 'error.main',
                    fontWeight: 600
                  }}>
                    {stat.change}
                  </Typography>
                </Box>
              </Paper>
            </Grow>
          </Grid>
        ))}
      </Grid>

      {/* Quick Actions */}
      <Paper elevation={2} sx={{ p: 3, borderRadius: 3, mb: 4 }}>
        <Typography variant="h6" gutterBottom sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
          <DashboardIcon /> Quick Actions
        </Typography>
        <Grid container spacing={2}>
          {quickActions.map((action, index) => (
            <Grid item xs={6} sm={4} md={3} lg={2.4} key={index}>
              <Fade in timeout={index * 100 + 500}>
                <Button
                  fullWidth
                  variant="contained"
                  startIcon={action.icon}
                  onClick={action.action}
                  sx={{
                    p: 2.5,
                    flexDirection: 'column',
                    height: '100%',
                    minHeight: 110,
                    bgcolor: `${action.color}.main`,
                    '&:hover': {
                      bgcolor: `${action.color}.dark`,
                      transform: 'scale(1.02)'
                    },
                    transition: 'all 0.3s'
                  }}
                >
                  <Typography variant="body2" sx={{ color: 'white', textAlign: 'center', fontWeight: 500 }}>
                    {action.label}
                  </Typography>
                </Button>
              </Fade>
            </Grid>
          ))}
        </Grid>
      </Paper>

      {/* Features Showcase */}
      <Paper elevation={2} sx={{ p: 3, borderRadius: 3, mb: 4 }}>
        <Typography variant="h5" gutterBottom sx={{ display: 'flex', alignItems: 'center', gap: 1, mb: 3 }}>
          <WorkspacesIcon /> Complete e-LMS Features
        </Typography>
        <Grid container spacing={3}>
          {allFeatures.map((category, index) => (
            <Grid item xs={12} md={6} lg={4} key={index}>
              <Card sx={{ height: '100%' }}>
                <CardContent>
                  <Box sx={{ display: 'flex', alignItems: 'center', gap: 2, mb: 2 }}>
                    <Box sx={{
                      p: 1.5,
                      borderRadius: 2,
                      bgcolor: alpha(theme.palette[category.color].main, 0.1),
                      color: theme.palette[category.color].main
                    }}>
                      {category.icon}
                    </Box>
                    <Typography variant="h6">{category.category}</Typography>
                  </Box>
                  <List dense>
                    {category.features.map((feature, idx) => (
                      <ListItem key={idx} sx={{ py: 0.5 }}>
                        <ListItemIcon sx={{ minWidth: 30 }}>
                          <CheckCircleIcon fontSize="small" color="success" />
                        </ListItemIcon>
                        <ListItemText primary={feature} />
                      </ListItem>
                    ))}
                  </List>
                </CardContent>
              </Card>
            </Grid>
          ))}
        </Grid>
      </Paper>
    </>
  );

  return (
    <Box sx={{ width: '100%', minHeight: '100vh', bgcolor: alpha(theme.palette.info.main,1), }}>
      <Navbar />

      {/* Hero Section */}
    <Box
        sx={{
          bgcolor: alpha(theme.palette.primary.main, 0.2),
          pt: { xs: 6, sm: 8, md: 12 },
          pb: { xs: 6, sm: 6, md: 8 },
          position: 'relative',
          overflow: 'hidden'
        }}
      >
        {/* Animated Background Elements */}
        <Box
          sx={{
            position: 'absolute',
            top: '20%',
            left: '10%',
            width: 300,
            height: 300,
            borderRadius: '50%',
            background: `radial-gradient(circle, ${alpha(theme.palette.common.white, 0.1)} 0%, transparent 70%)`,
            animation: `${floatAnimation} 15s ease-in-out infinite`,
          }}
        />

        <Container maxWidth="xl">
          <Grid container spacing={{ xs: 4, md: 6 }} alignItems="center">
            <Grid item xs={12} lg={6}>
              <Box
                sx={{
                  display: "flex",
                  flexDirection: {
                    xs: "column",
                    sm: "column",
                    md: "row",
                  },
                  alignItems: "center",
                  gap: { xs: 2, md: 3 },
                  textAlign: {
                    xs: "center",
                    md: "left",
                  },
                  mb: 3,
                }}
              >
                <Box
                  component="img"
                  src={logoImage}
                  alt="Impulz e-LMS"
                  sx={{
                    width: {
                      xs: 200,
                      sm: 140,
                      md: 180,
                    },
                    height: {
                      xs: 200,
                      sm: 140,
                      md: 180,
                    },
                    objectFit: 'contain',

                  }}
                />
                <Box>
                  <Typography
                    variant="h1"
                    sx={{
                      fontSize: { xs: "2.5rem", md: "3.5rem" },
                      fontWeight: 900,
                      lineHeight: 1.2,
                      mb: 1,

                      background: "none",
                      WebkitTextFillColor: "initial",
                      color: "#f7e164",
                    }}
                  >
                    <Box component="span" sx={{ fontStyle: "italic", marginRight: 1 }}>
                      i
                    </Box>
                    <Box component="span" sx={{ color: "#f7ef81" }}>
                      mpulz LMS
                    </Box>
                  </Typography>



                  <Typography
                    variant="h4"
                    sx={{
                      color: "#1E40AF",
                      fontWeight: 600,
                      fontSize: {
                        xs: "2rem",
                        sm: "2.3rem",
                        md: "3rem",
                      },
                    }}
                  >
                    Complete School & College Learning Management System
                  </Typography>
                </Box>
              </Box>

              <Typography
                variant="h6"
                sx={{
                  color: alpha(theme.palette.common.white, 0.9),
                  mb: 4,
                  maxWidth: 600,
                  fontSize: {
                    xs: "1rem",
                    sm: "1.1rem",
                    md: "1.25rem",
                  },
                  textAlign: {
                    xs: "center",
                    md: "left",
                  },
                }}
              >
                iMPULZ is a powerful online platform designed to revolutionize education.
                It offers a comprehensive suite of tools for educators to create, manage and deliver online courses effectively.
                From course content creation to student assessment and feedback, Impulz provides a streamlined solution for both instructors and learners.

              </Typography>

              {/* <Box sx={{ display: 'flex', gap: 2, flexWrap: 'wrap' }}>

                <Button
                  variant="outlined"
                  size="large"
                  startIcon={<PlayCircleIcon />}
                  sx={{
                    px: 4,
                    py: 1.5,
                    fontSize: '1.1rem',
                    borderColor: 'white',
                    color: 'white',
                    '&:hover': {
                      borderColor: theme.palette.secondary.light,
                      backgroundColor: alpha(theme.palette.secondary.light, 0.1)
                    }
                  }}
                >
                  Watch Video
                </Button>
                <Button
                  variant="outlined"
                  size="large"
                  startIcon={<DownloadIcon />}
                  sx={{
                    px: 4,
                    py: 1.5,
                    fontSize: '1.1rem',
                    borderColor: 'white',
                    color: 'white',
                    '&:hover': {
                      borderColor: theme.palette.success.light,
                      backgroundColor: alpha(theme.palette.success.light, 0.1)
                    }
                  }}
                >
                  Download Brochure
                </Button>
              </Box> */}
            </Grid>

            <Grid item xs={12} lg={6}>
              <Zoom in timeout={1000}>
                <Box
                  sx={{
                    position: 'relative',
                    animation: `${floatAnimation} 6s ease-in-out infinite`
                  }}
                >
                  <Paper
                    elevation={24}
                    sx={{
                      p: {
                        xs: 2,
                        sm: 3,
                        md: 4,
                      },
                      background: `linear-gradient(135deg, ${alpha(theme.palette.common.white, 0.95)} 0%, ${alpha(theme.palette.common.white, 0.85)} 100%)`,
                      backdropFilter: 'blur(10px)',
                      borderRadius: 4,
                      transform: 'rotateY(5deg) rotateX(5deg)',
                      transition: 'transform 0.5s',
                      '&:hover': {
                        transform: 'rotateY(0deg) rotateX(0deg) scale(1.02)'
                      }
                    }}
                  >
                    <Typography variant="h4" gutterBottom sx={{ color: theme.palette.primary.main, fontWeight: 700 }}>
                      Why Choose <Box component="span" sx={{ fontStyle: "italic", marginRight: .32 }}>
                        i
                      </Box>mpulz LMS?
                    </Typography>

                    <List>
                      {[
                        'Complete end-to-end solution',
                        'Cloud-based & secure',
                        'Mobile app available',
                        '24/7 support',
                        'Customizable modules',
                        'Real-time analytics',
                        'Multi-language support',

                      ].map((item, index) => (
                        <ListItem key={index} sx={{ py: 1 }}>
                          <ListItemIcon>
                            <CheckCircleIcon color="success" />
                          </ListItemIcon>
                          <ListItemText primary={item} />
                        </ListItem>
                      ))}
                    </List>

                    <Box sx={{ mt: 4, p: 3, bgcolor: alpha(theme.palette.primary.main, 0.1), borderRadius: 3 }}>
                      <Typography variant="h6" gutterBottom>
                        Trusted by 500+ Institutions
                      </Typography>
                      <Typography variant="body2">
                        Schools & Colleges & Universities and Training Institutes across 25+ countries
                      </Typography>
                    </Box>
                  </Paper>
                </Box>
              </Zoom>
            </Grid>
          </Grid>
        </Container>
      </Box>

      {/* Main Dashboard Content */}
      <Container maxWidth="xl" sx={{ py: 8 }}>
        <Typography variant="h2" align="center" gutterBottom sx={{ fontWeight: 800, mb: 6 }}>
          Complete Feature Set
        </Typography>

        {renderDashboard()}
      </Container>

      {/* Modals */}
      <Dialog open={attendanceModal} onClose={() => setAttendanceModal(false)} maxWidth="sm" fullWidth>
        <DialogTitle>Mark Attendance</DialogTitle>
        <DialogContent>
          <Typography>Attendance marking interface...</Typography>
        </DialogContent>
        <DialogActions>
          <Button onClick={() => setAttendanceModal(false)}>Cancel</Button>
          <Button variant="contained" onClick={handleAttendanceSubmit}>
            Submit
          </Button>
        </DialogActions>
      </Dialog>

      <Snackbar
        open={notification.open}
        autoHideDuration={6000}
        onClose={handleCloseNotification}
        anchorOrigin={{ vertical: 'bottom', horizontal: 'right' }}
      >
        <Alert onClose={handleCloseNotification} severity={notification.type} sx={{ width: '100%' }}>
          {notification.message}
        </Alert>
      </Snackbar>

      <HomeFooter />
    </Box>
  );
};

export default ImpulzELMS;
